import { ICategoryVote } from 'api/types/_campaign';
import { ICategory } from 'api/types/_category';
import { INews, IPartner } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_INFO, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TableContainer from 'components/Common/TableContainer';
import { useRole } from 'components/Hooks/UserHooks';
import { COLORS_KEYWORD_TYPE, COLORS_RANK_NEWS, COLORS_STATUS_NEWS, KEYWORD_PUBLISH_LOG_TYPE_OPTIONS, KEYWORD_TYPE, KEYWORD_TYPE_OPTIONS, NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS, PUBLISH_NEWS_TYPE, RANK_NEWS_OPTIONS, SECTION_KEYWORD, SECTION_TYPE_CONTENT_OPTIONS, SENTIMENT_NEWS_OPTIONS, STATUS_ARTICLE_OPTIONS, STATUS_NEWS_OPTIONS, TEXT_NAME_CATEGORY_IS_STAR_TREND_KEYWORD } from 'helpers/constans';
import { filterMediaOptions, formatGetSource, formatNumberWithCommas } from 'helpers/format';
import { ROLES_FOR_APP, isHavePermissionRole } from 'helpers/role';
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { allCategoryVote, deleteNewsMulti, downloadExcelNews, getAINewsByNormal, getAllCategory, getAllImageCategory, getAllPartners, getGenerateBoostingNews, getNewsKeywords as onGetNewsKeywords, postGenerateBoostingNews, putGenerateBoostingNews, putNews } from 'store/thunks';
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import BoxFooterNews from '../Components/BoxFooterNews';
import BoxGeneratedNews from '../Components/BoxGeneratedNews';
import BoxImageSearch from '../Components/BoxImageSearch';
import BoxSourceNews from '../Components/BoxSourceNews';
import BoxVoteKeyword from '../Components/BoxVoteKeyword';
import ButtonLanguage from '../Components/ButtonLanguage';
import HighlightText from '../Components/HighlightText';
import NestingFilter from '../Components/NestingFilter';
import { formatClearHighlightTextWithDateAndKeyword } from '../functions';
import ModalGenerateBoostingNewsV2 from './ModalGenerateBoostingNewsV2';
import ModalImportGenerateBoostingNews from './ModalImportGenerateBoostingNews';
import ModalLogGenerateBoostingNews from './ModalLogGenerateBoostingNews';

interface Option {
  label: string;
  value: string;
}

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'date'; // 'last_published_at';

const BoostingNewsList = () => {
  let document_w: any = window.document;
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const modalRef = useRef<any>(null);
  const modalBodyInnerRef = useRef<any>(null);

  const modalSourceInnerRefs = useRef<any>([]);

  const isFirstLoadingPageRef = useRef<any>(true);

  const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const SENTIMENT_NEWS_OPTIONS_LANG = SENTIMENT_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const RANK_NEWS_OPTIONS_LANG = RANK_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const STATUS_KEYWORD_NEWS_OPTIONS_LANG = [{ label: 'Used', value: '1' }, { label: 'Unused', value: '0' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const TYPE_TASK_KEYWORD_OPTIONS_LANG = [{ label: 'Included2', value: '1' }, { label: 'Not Included2', value: '0' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const KEYWORD_TYPE_OPTIONS_LANG = KEYWORD_TYPE_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const KEYWORD_PUBLISH_LOG_TYPE_OPTIONS_LANG = KEYWORD_PUBLISH_LOG_TYPE_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const SECTION_TYPE_CONTENT_OPTIONS_LANG = SECTION_TYPE_CONTENT_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS_LANG = NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const STATUS_ARTICLE_OPTIONS_LANG = STATUS_ARTICLE_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const START_DATE = `${moment().format("Y-MM-DD")}`;
  const END_DATE = `${moment().format("Y-MM-DD")}`;


  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    start_date: withDefault(StringParam, START_DATE),
    end_date: withDefault(StringParam, END_DATE),
    keyword: withDefault(StringParam, ''),
    media_name: withDefault(StringParam, ''),
    news_title: withDefault(StringParam, ''),
    reporter_id: withDefault(StringParam, ''),
    reporter_name: withDefault(StringParam, ''),
    is_used: withDefault(StringParam, ''),
    is_completed: withDefault(StringParam, ''),
    section: withDefault(StringParam, `${SECTION_KEYWORD.BOOSTING}`),
    category_id: withDefault(StringParam, ''),
    // type_page_no_param: withDefault(StringParam, ''),
    exposure_rank_type: withDefault(StringParam, ''),
    last_published_at_start: withDefault(StringParam, ''),
    last_published_at_end: withDefault(StringParam, ''),
    daily_search_volume_start: withDefault(StringParam, ''),
    daily_search_volume_end: withDefault(StringParam, ''),
    // source_cluster_count_start: withDefault(StringParam, ''),
    // source_cluster_count_end: withDefault(StringParam, ''),
    // source_word_count_body_start: withDefault(StringParam, ''),
    // source_word_count_body_end: withDefault(StringParam, ''),
    article_count_start: withDefault(StringParam, ''),
    article_count_end: withDefault(StringParam, ''),
    pa_index_start: withDefault(StringParam, ''),
    pa_index_end: withDefault(StringParam, ''),
    affiliate_rank_start: withDefault(StringParam, ''),
    affiliate_rank_end: withDefault(StringParam, ''),
    news_section_rank_start: withDefault(StringParam, ''),
    news_section_rank_end: withDefault(StringParam, ''),
    // keyword_type: withDefault(StringParam, ''),
    // keyword_publish_log_type: withDefault(StringParam, ''),
    type: withDefault(StringParam, `${KEYWORD_TYPE.NEWS_V2}`),
    published_media_id: withDefault(StringParam, ''),
    keyword_task_group: withDefault(StringParam, ''),
  });

  const [listCategoryVote, setListCategoryVote] = useState<ICategoryVote[]>([]);

  const [isLoadingExportFile, setIsLoadingExportFile] = useState<boolean>(false);

  const [listCategory, setListCategory] = useState<ICategory[]>([]);

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

  const [mediaSearch, setMediaSearch] = useState<string>(query?.media_name || '');

  const [mediaPublishedSearch, setMediaPublishedSearch] = useState<Option | null>(!!query?.published_media_id ? { value: `${query?.published_media_id}`, label: '' } : null);

  const [titleSearch, setTitleSearch] = useState<string>(query?.news_title || "");

  const [reporterIdSearch, setReporterIdSearch] = useState<Option | null>(!!query?.reporter_id ? { value: `${query?.reporter_id}`, label: '' } : null);

  const [reporterNameSearch, setReporterNameSearch] = useState<string>(query?.reporter_name || "");

  const [keywordPublishLogTypeSearch, setKeywordPublishLogTypeSearch] = useState<Option | null>(KEYWORD_PUBLISH_LOG_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.keyword_publish_log_type)) || null);

  const [typeSearch, setTypeSearch] = useState<Option | null>(KEYWORD_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.type)) || null);

  const [rankSearch, setRankSearch] = useState<Option | null>(RANK_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.exposure_rank_type)) || null);

  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_KEYWORD_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.is_used)) || null);

  const [statusArticleSearch, setStatusArticleSearch] = useState<Option | null>(STATUS_ARTICLE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.is_completed)) || null);

  const [typeTaskKeywordSearch, setTypeTaskKeywordSearch] = useState<Option | null>(NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.keyword_task_group)) || null);

  const [typeSectionContentSearch, setTypeSectionContentSearch] = useState<Option | null>(SECTION_TYPE_CONTENT_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.section)) || null);

  const [sentimentSearch, setSentimentSearch] = useState<Option | null>(SENTIMENT_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.sentiment_value)) || null);

  const [startArticleCountSearch, setStartArticleCountSearch] = useState<string>(query?.article_count_start || "");
  const [endArticleCountSearch, setEndArticleCountSearch] = useState<string>(query?.article_count_end || "");

  const [startDailyVolumeSearch, setStartDailyVolumeSearch] = useState<string>(query?.daily_search_volume_start || "");
  const [endDailyVolumeSearch, setEndDailyVolumeSearch] = useState<string>(query?.daily_search_volume_end || "");

  const [startPAIndexSearch, setStartPAIndexSearch] = useState<string>(query?.pa_index_start || "");
  const [endPAIndexSearch, setEndPAIndexSearch] = useState<string>(query?.pa_index_end || "");

  const [startAffiliateSearch, setStartAffiliateSearch] = useState<string>(query?.affiliate_rank_start || "");
  const [endAffiliateSearch, setEndAffiliateSearch] = useState<string>(query?.affiliate_rank_end || "");

  const [startLastPublishedSearch, setStartLastPublishedSearch] = useState<string>(query?.last_published_at_start || "");
  const [endLastPublishedSearch, setEndLastPublishedSearch] = useState<string>(query?.last_published_at_end || "");

  const [startNewsSectionSearch, setStartNewsSectionSearch] = useState<string>(query?.news_section_rank_start || "");
  const [endNewsSectionSearch, setEndNewsSectionSearch] = useState<string>(query?.news_section_rank_end || "");

  const [startClusterSearch, setStartClusterSearch] = useState<string>(query?.source_cluster_count_start || "");
  const [endClusterSearch, setEndClusterSearch] = useState<string>(query?.source_cluster_count_end || "");

  const [startArticleWordCountSearch, setStartArticleWordCountSearch] = useState<string>(query?.source_word_count_body_start || "");
  const [endArticleWordCountSearch, setEndArticleWordCountSearch] = useState<string>(query?.source_word_count_body_end || "");


  const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
  const [startDate, endDate] = dateSearch;

  const [newsDetail, setNewsDetail] = useState<INews | null>(null);

  const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
  const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<INews | null>(null);

  const [imageCategories, setImageCategories] = useState<any>([]);
  const [imageInsert, setImageInsert] = useState<any>(null);

  const [voteInsert, setVoteInsert] = useState<any>(null);

  const [partners, setPartners] = useState<IPartner[]>([]);

  const [listMediaPublished, setListMediaPublished] = useState<Option[]>([]);

  const [listReporter, setListReporter] = useState<any[]>([]);

  const [isOpenModalNews, setIsOpenModalNews] = useState<boolean>(false);

  const [isOpenModalGenerateBoostingNewsV2, setIsOpenModalGenerateBoostingNewsV2] = useState<boolean>(false);

  const [isOpenImportGenerateBoostingNews, setIsOpenImportGenerateBoostingNews] = useState<boolean>(false);

  const [isOpenLogGenerateBoostingNews, setIsOpenLogGenerateBoostingNews] = useState<boolean>(false);

  const [queryModal, setQueryModal]: any = useState({
    time_request: 0,
    page: 1,
    limit: 500,
    sort_by: 'id',
    order_by: 'DESC',
    start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
    end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
    news_ids: '',
    section: `${SECTION_KEYWORD.BOOSTING}`,
    type_page_no_param: '',
  });


  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.News;

  const NewsProperties = createSelector(
    selectLayoutState,
    (state) => ({
      keywords: state.keywords,
      isKeywordSuccess: state.isKeywordSuccess,
      isKeywordLoading: state.isKeywordLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { keywords, error, isKeywordLoading } = useSelector(NewsProperties);

  const onSetImageInsert = (item: any) => {
    setImageInsert((_prev: any) => item);
  }

  const onSetVoteKeywordInsert = (item: any) => {
    setVoteInsert((_prev: any) => item);
  }

  const handleQueryData = async () => {
    setIsListNewsLoading((prev) => true);
    const res: any = await getAINewsByNormal(queryModal);
    setListNews((prev: any) => ({
      list: res?.data?.list || [],
      total: res?.data?.pagination?.total || 0,
    }));
    setIsListNewsLoading((prev) => false);
    if (queryModal?.page === 1) {
      setNewsDetail((_prev) => (res?.data?.list?.find((_n: any) => String(_n?.id) === String(newsDetail?.id)) || res?.data?.list[0]));
    }

    if (!!newsDetail && queryModal?.type_page_no_param) {
      if (queryModal?.type_page_no_param === 'prev') {
        setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
        return;
      }
      if (queryModal?.type_page_no_param === 'next') {
        setNewsDetail((_prev) => res?.data?.list[0]);
        return;
      }
    }
  };

  const handleLoadMore = () => {
    setQueryModal((_prev: any) => ({
      ..._prev,
      page: queryModal?.page + 1,
      type_page_no_param: 'next'
    }));
  }

  const handleLoadPrev = () => {
    setQueryModal((_prev: any) => ({
      ..._prev,
      page: queryModal?.page - 1,
      type_page_no_param: 'prev'
    }));
  }


  useEffect(() => {
    const queryClone = structuredClone(query);
    queryClone.reporter_id = queryClone?.reporter_id || queryClone?.reporter_name || '';
    queryClone.reporter_name = '';
    dispatch(onGetNewsKeywords(queryClone));
  }, [JSON.stringify(query)]);

  const searchData = () => {
    const queryNew = {
      ...query,
      start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      keyword: keywordSearch || '',
      news_title: titleSearch || '',
      reporter_id: reporterIdSearch?.value || '',
      reporter_name: reporterNameSearch || '',
      media_name: mediaSearch || '',
      published_media_id: mediaPublishedSearch?.value || '',
      is_used: statusSearch?.value,
      is_completed: statusArticleSearch?.value,
      keyword_task_group: typeTaskKeywordSearch?.value ?? '',
      sentiment_value: sentimentSearch?.value,
      exposure_rank_type: rankSearch?.value,
      type: typeSearch?.value,
      keyword_publish_log_type: keywordPublishLogTypeSearch?.value || '',
      last_published_at_start: startLastPublishedSearch || '',
      last_published_at_end: endLastPublishedSearch || '',
      daily_search_volume_start: startDailyVolumeSearch || '',
      daily_search_volume_end: endDailyVolumeSearch || '',
      source_cluster_count_start: startClusterSearch || '',
      source_cluster_count_end: endClusterSearch || '',
      source_word_count_body_start: startArticleWordCountSearch || '',
      source_word_count_body_end: endArticleWordCountSearch || '',
      article_count_start: startArticleCountSearch || '',
      article_count_end: endArticleCountSearch || '',
      pa_index_start: startPAIndexSearch || '',
      pa_index_end: endPAIndexSearch || '',
      affiliate_rank_start: startAffiliateSearch || '',
      affiliate_rank_end: endAffiliateSearch || '',
      news_section_rank_start: startNewsSectionSearch || '',
      news_section_rank_end: endNewsSectionSearch || '',
      section: typeSectionContentSearch?.value ? typeSectionContentSearch?.value : `${SECTION_KEYWORD.BOOSTING}`,
      page: 1,
      time_request: + new Date()
    };
    // if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
    //   setListNews((prev: any) => ({
    //     list: [],
    //     total: 0,
    //   }));
    // }
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      news_title: '',
      reporter_id: '',
      reporter_name: '',
      keyword: '',
      media_name: '',
      published_media_id: '',
      is_used: '',
      is_completed: '',
      keyword_task_group: '',
      section: `${SECTION_KEYWORD.BOOSTING}`,
      type: `${KEYWORD_TYPE.NEWS_V2}`,
      category_id: '',
      sentiment_value: '',
      exposure_rank_type: '',
      keyword_type: '',
      keyword_publish_log_type: '',
      last_published_at_start: '',
      last_published_at_end: '',
      daily_search_volume_start: '',
      daily_search_volume_end: '',
      source_cluster_count_start: '',
      source_cluster_count_end: '',
      source_word_count_body_start: '',
      source_word_count_body_end: '',
      article_count_start: '',
      article_count_end: '',
      pa_index_start: '',
      pa_index_end: '',
      affiliate_rank_start: '',
      affiliate_rank_end: '',
      news_section_rank_start: '',
      news_section_rank_end: '',
      start_date: `${moment().format("Y-MM-DD")}`,
      end_date: `${moment().format("Y-MM-DD")}`,
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: 'DESC',
      page: 1,
      time_request: + new Date(),
    };
    // if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
    //   setListNews((prev: any) => ({
    //     list: [],
    //     total: 0,
    //   }));
    // }
    setQuery(queryNew, "push");
    setTitleSearch((_prev) => "");
    setReporterIdSearch((_prev) => null);
    setReporterNameSearch((_prev) => "");
    setKeywordSearch((_prev) => "");
    setMediaSearch((_prev) => '');
    setMediaPublishedSearch((_prev) => null);
    setStatusSearch(null);
    setStatusArticleSearch(null);
    setSentimentSearch(null);
    setRankSearch(null);
    setTypeSearch(KEYWORD_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(queryNew?.type)) || null);
    setTypeSectionContentSearch(null);
    setKeywordPublishLogTypeSearch(null);
    setTypeTaskKeywordSearch(null);
    setDateSearch([moment(queryNew?.start_date || "", 'Y-MM-DD').toDate(), moment(queryNew?.end_date || "", 'Y-MM-DD').toDate()]);
    setStartDailyVolumeSearch(queryNew?.daily_search_volume_start);
    setEndDailyVolumeSearch(queryNew?.daily_search_volume_end);
    setStartClusterSearch(queryNew?.source_cluster_count_start);
    setEndClusterSearch(queryNew?.source_cluster_count_end);
    setStartArticleWordCountSearch(queryNew?.source_word_count_body_start);
    setEndArticleWordCountSearch(queryNew?.source_word_count_body_end);
    setStartArticleCountSearch(queryNew?.article_count_start);
    setEndArticleCountSearch(queryNew?.article_count_end);
    setStartPAIndexSearch(queryNew?.pa_index_start);
    setEndPAIndexSearch(queryNew?.pa_index_end);
    setStartNewsSectionSearch(queryNew?.news_section_rank_start);
    setEndNewsSectionSearch(queryNew?.news_section_rank_end);
    setStartAffiliateSearch(queryNew?.affiliate_rank_start);
    setEndAffiliateSearch(queryNew?.affiliate_rank_end);
    setStartLastPublishedSearch(queryNew?.last_published_at_start);
    setEndLastPublishedSearch(queryNew?.last_published_at_end);
  };

  useEffect(() => {
    if (!!queryModal?.news_ids) {
      handleQueryData();
    }
  }, [JSON.stringify(queryModal)]);

  const handleShowModalNews = (__news_ids: number[], __default_news_id: number | null = null) => {
    setQueryModal((_prev: any) => ({
      ..._prev,
      news_ids: (__news_ids || [])?.join(','),
      is_used: query?.is_used ?? '',
      start_date: query?.start_date ? moment(new Date(query?.start_date)).format("Y-MM-DD") : '',
      end_date: query?.end_date ? moment(new Date(query?.end_date)).format("Y-MM-DD") : '',
      type_page_no_param: '',
      page: 1
    }));
    if (!!__default_news_id) {
      setNewsDetail((_prev) => ({ ..._prev, id: __default_news_id } as INews));
    }
    setIsOpenModalNews((_prev) => true);
  };

  const handleCloseModalNews = () => {
    setIsOpenModalNews((_prev) => false);
    setQueryModal((_prev: any) => ({
      ..._prev,
      page: 1,
      news_ids: '',
    }))
  };

  const handleSetNewsDetail = (detail: INews | null) => {
    setNewsDetail((_prev) => detail);
    if (!!detail && (window?.innerWidth <= 900) && (!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
      setTimeout(async () => {
        try {
          if (modalRef.current && modalRef.current.requestFullscreen) {
            await modalRef?.current?.requestFullscreen();
          } else if (modalRef.current && modalRef.current.webkitRequestFullscreen) {
            await modalRef?.current?.webkitRequestFullscreen(); // Safari
          } else if (modalRef.current && modalRef.current.msRequestFullscreen) {
            await modalRef?.current?.msRequestFullscreen(); // IE
          }
        } catch (error) {
          //console.error("Failed to enter fullscreen:", error);
        }
      }, 280);
    }
  };

  const onCloseClick = () => {
    handleCloseModalNews();
    setCurrentLang((_prev) => 'ko');
    handleSetNewsDetail(null);
    onSetImageInsert(null);
    onSetVoteKeywordInsert(null);
    setTypeShowInfoRight((_prev) => 'SOURCE');
    setListNews((prev: any) => ({
      list: [],
      total: 0,
    }));
  }

  const [typeShowInfoRight, setTypeShowInfoRight] = useState<'IMAGE' | 'SOURCE'>('SOURCE');
  const onShowInfoRightClick = () => {
    setTypeShowInfoRight((_prev) => (_prev === 'IMAGE' ? 'SOURCE' : 'IMAGE'));
  }

  const refContentNews = useRef<any>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const resetCursorToStart = () => {
    const editor = refContentNews?.current;
    if (editor) {
      // Find the first <br> tag or &nbsp; in the content after insertion
      const body = editor.getBody();
      const brNode = body.querySelector('br'); // Find the first <br> tag
      let targetNode = null;

      if (brNode) {
        targetNode = brNode; // Prioritize the <br> tag
      } else {
        // If no <br> is found, search for &nbsp; in text nodes
        const textNodes = Array.from(body.childNodes).filter(
          (node: any) => node.nodeType === Node.TEXT_NODE && node.nodeValue?.includes('\u00A0')
        );
        if (textNodes.length > 0) {
          targetNode = textNodes[0];
        }
      }

      if (targetNode) {
        // Place the cursor immediately after the <br> tag or &nbsp;
        const parentNode = targetNode.parentNode;
        const offset = Array.from(parentNode.childNodes).indexOf(targetNode) + 1;
        editor.selection.setCursorLocation(parentNode, offset);
      }

      // Update the bookmark state at the new cursor location
      const newBookmark = editor.selection.getBookmark();
      // editor?.selection.setCursorLocation(null, 0);
    }

  };

  const onSaveClick = async (is_show_noti_when_success: boolean = true) => {
    try {
      if (!newsDetail?.id) {
        return;
      }

      setIsSaving((_prev) => true);
      const response: any = await putNews(newsDetail?.id, {
        title: refContentNews?.current?.getTitle() || '',
        body: formatClearHighlightTextWithDateAndKeyword(refContentNews?.current?.getContent() || '')
      });
      if (response?.code === 200) {
        setListNews((prev: any) => ({
          list: (prev?.list || []).map((item: any) => {
            if (String(item?.id) === String(newsDetail?.id)) {
              return ({ ...item, ...response?.data })
            }
            return item;
          }),
          total: Number(prev?.total || 0),
        }));
        setNewsDetail((_prev: any) => ({ ..._prev, ...response?.data }));
        setIsSaving((_prev) => false);
        if (is_show_noti_when_success) {
          toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        }
      } else {
        setIsSaving((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsSaving((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const scrollModalBodyToTop = () => {
    if (modalBodyInnerRef.current) {
      modalBodyInnerRef.current.scrollTo({ top: 0 });
    }
    if (modalSourceInnerRefs.current) {
      modalSourceInnerRefs.current.forEach((ref: any) => {
        if (ref) {
          ref.scrollTo({ top: 0 });
        }
      });
    }
  };

  const handlePreviousNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsPrevious = Number(index_news_current) - 1;
      const newsPrevious = listNews?.list[indexNewsPrevious];
      if (!!newsPrevious) {
        handleSetNewsDetail({
          ...(newsPrevious),
          index: indexNewsPrevious,
          disabled_prev: false,
          disabled_next: false
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
      }
      if (!newsPrevious) {
        if (Number(queryModal?.page) > 1) {
          handleLoadPrev();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const handleNextNews = (index_news_current: number = 0) => {
    if (listNews?.list?.length) {
      const indexNewsNext = Number(index_news_current) + 1;
      const newsNext = listNews?.list[indexNewsNext];
      if (!!newsNext) {
        handleSetNewsDetail({
          ...(newsNext),
          index: indexNewsNext,
          disabled_prev: false,
          disabled_next: false,
        });
        scrollModalBodyToTop();
        setCurrentLang((_prev) => 'ko');
      }
      if (!newsNext) {
        if (Number(queryModal?.page) < Math.ceil(Number(listNews?.total) / Number(queryModal?.limit || 300))) {
          handleLoadMore();
        } else {
          toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
        }
      }
    }
  };

  const handleDownloaded = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
      dispatch(onGetNewsKeywords(query));
    }
  };

  const handlePublished = (info: any, is_refresh_category: boolean = false) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
      dispatch(onGetNewsKeywords(query));
      if (!!is_refresh_category) {
        handleRefreshCategory();
      }
    }
  };

  const handleUnPublished = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
      dispatch(onGetNewsKeywords(query));
    }
  };

  const handleCopied = (info: any) => {
    if (!!info?.id) {
      setListNews((prev: any) => ({
        list: (prev?.list || []).map((item: any) => {
          if (String(item?.id) === String(info?.id)) {
            return ({ ...item, ...info })
          }
          return item;
        }),
        total: Number(prev?.total || 0),
      }));
      setNewsDetail((_prev: any) => ({ ..._prev, ...info }));
      dispatch(onGetNewsKeywords(query));
    }
  };

  const handleGenerateNews = (info: any) => {
    if (!!info?.id) {
      dispatch(onGetNewsKeywords(query));
    }
  };


  const [currentLang, setCurrentLang] = useState<string>('ko');
  const handleChangeLang = (_lang: string) => {
    const lang = newsDetail?.translates?.find((tr) => tr?.language_code === _lang);
    setNewsDetail((_prev) => (
      {
        ..._prev,
        title: lang?.title,
        body: lang?.body,
      } as INews
    ));
    setCurrentLang((_prev) => _lang);
  };

  // Begin::Delete
  const handleConfirmDelete = (item: INews) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!(initialValuesDefault?.id)) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteNewsMulti({
        ids: [initialValuesDefault?.id]
      });
      if (response?.code === 200) {
        setListNews((prev: any) => ({
          list: (prev?.list || []).filter((item: any) => String(item?.id) !== String(initialValuesDefault?.id)),
          total: Number(prev?.total || 0) - 1,
        }));
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete

  const handleDownloadExcel = async () => {
    try {
      setIsLoadingExportFile((_prev) => true);
      const response: any = await downloadExcelNews({ ...queryModal });
      if (response?.data) {
        setIsLoadingExportFile((_prev) => false);
        const link = document.createElement('a');
        link.href = response?.data?.url;
        link.download = 'boosting_keywords';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setIsLoadingExportFile((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingExportFile((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const triggerRefresh = () => {
    dispatch(onGetNewsKeywords(query));
    setIsOpenModalGenerateBoostingNewsV2((_prev) => false);
    setIsOpenImportGenerateBoostingNews((_prev) => false);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "align-middle text-center",
        Cell: (cell: any) => (
          <>

            <div className="text-center" style={{ minWidth: '80px' }}>
              <CopyWrapper contentCopy={cell?.value}>
                {cell?.value}
              </CopyWrapper>
            </div>

          </>
        ),
      },
      // {
      //   Header: t('Type'),
      //   accessor: "type",
      //   filterable: false,
      //   sortable: false,
      //   thClass: "align-middle text-center",
      //   thWidth: i18n?.language === 'en' ? 90 : 80,
      //   Cell: (cell: any) => {
      //     const item: any = cell?.row?.original;
      //     return (
      //       <div style={{ minWidth: '60px' }} className="text-center fs-16">
      //         <span className={`rounded-pill badge bg-${COLORS_KEYWORD_TYPE[`${cell?.value || 0}`] || 'success'}`}>
      //           {KEYWORD_TYPE_OPTIONS_LANG?.find((s: any) => String(s?.value) === String(cell?.value))?.label || ''}
      //         </span>
      //       </div>
      //     );
      //   }
      // },
      // {
      //   Header: t('Media'),
      //   accessor: "published_media_id",
      //   filterable: true,
      //   sortable: false,
      //   thClass: 'text-start align-middle',
      //   thWidth: 130,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (<>
      //       <div className="text-start hover-underline-primary pe-3" style={{ minWidth: '100px' }}>
      //         <Link
      //           className="nav-link"
      //           target="_blank"
      //           to={item?.news_link || ''} >
      //           {cell?.value || '-'}
      //         </Link>
      //       </div>
      //     </>)
      //   },
      // },
      {
        Header: t('Category'),
        accessor: "category",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: 'align-middle text-start',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: '100px' }} className="d-flex flex-column align-items-start gap-2">
            {(item?.categories || [])?.map((_c: any) => (
              <span className="rounded-pill badge bg-primary-subtle text-primary fs-13" key={_c?.id}>{_c?.name}</span>
            ))}
          </div>)
        },
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: 'align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="d-flex justify-content-between align-items-center cursor-pointer ">
              <Link className='text-normal nav-link  flex-grow-1 hover-underline' to={`https://search.naver.com/search.naver?ssc=tab.news.all&where=news&sm=tab_jum&query=${cell?.value || ''}`} target="_blank" style={{ minWidth: '100px' }}>
                {cell?.value}
              </Link>
              {!!item?.is_keyword_task &&
                <i className="bx bx-circle text-info fs-20" />}
            </div>
          </>)
        },
      },
      {
        Header: t('Articles'),
        accessor: "article_count",
        filterable: true,
        sortable: true,
        thWidth: 100,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-3 cursor-pointer hover-underline" onClick={() => handleShowModalNews(item?.id)} style={{ minWidth: '80px' }}
            >
              {formatNumberWithCommas(item?.article_used_count || 0)} / {formatNumberWithCommas(cell?.value || 0)}
              {/* <button className="btn btn-sm ms-1 fs-13" style={{ borderRadius: '15px', padding: '2px 2px' }} onClick={() => handleShowModalNews(item?.id)}>
                <i className="ri-eye-fill align-bottom text-secondary"></i>
              </button> */}
            </div>
          </>)
        },
      },
      {
        Header: t('Article Title'),
        accessor: "articles",
        filterable: true,
        sortable: false,
        thWidth: !keywords?.list?.length ? 100 : (window.innerWidth < 1650 ? 430 : 770),
        thClass: 'align-middle text-start',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const news_ids = item?.articles?.map((_a: any) => _a?.id);
          return (<>
            <div className="text-start d-flex flex-column gap-2" style={{ minWidth: '100px' }}
            >
              {(item?.articles || [])?.map((_a: any) => (
                <div key={_a?.id} style={{ minWidth: '250px', maxWidth: '730px' }} className="fs-15  d-flex align-items-center" onClick={() => handleShowModalNews(news_ids, _a?.id)}>
                  <i className={`ri-checkbox-blank-circle-fill me-1 fs-18 ${!!_a?.is_used ? 'text-danger' : 'text-success'} `} style={{ opacity: 0.8 }} />
                  <div className="cursor-pointer hover-underline">
                    <span className="text-muted" style={{ minWidth: '83px' }}>{_a?.created_at_label || ''}</span>
                    <span className="text-muted ms-1">|</span>
                    <span className="align-middle  me-1">{!!_a?.is_completed ? <i className='ri-checkbox-line fs-19 text-success' /> : <i className='ri-checkbox-indeterminate-line fs-19 text-danger' />}</span>
                    <HighlightText text={_a?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} />
                  </div>
                  <span className={`ms-2 rounded-pill badge bg-${COLORS_KEYWORD_TYPE[`${_a?.type || 0}`] || 'success'}-subtle text-${COLORS_KEYWORD_TYPE[`${_a?.type || 0}`] || 'success'}`}>
                    {KEYWORD_TYPE_OPTIONS_LANG?.find((s: any) => String(s?.value) === String(_a?.type))?.label || ''}
                  </span>
                  <span className={`ms-2 rounded-pill badge bg-secondary-subtle text-secondary`}>
                    {SECTION_TYPE_CONTENT_OPTIONS_LANG?.find((s: any) => String(s?.value) === String(_a?.section))?.label || ''}
                  </span>
                  {
                    _a.categories?.map((nc: any) => {
                      return <span className="ms-2 rounded-pill badge bg-primary-subtle text-primary" key={nc.id}>{nc.name}</span>
                    })
                  }

                  {(!!_a?.media_id || !!_a?.media_name || !!_a?.preset_media_name) && <span className="ms-2 badge bg-info-subtle text-info">
                    {!!_a?.media_id ? (_a?.media_name || '') : (_a?.preset_media_name || '')}
                  </span>}
                </div>
              ))}
            </div>
          </>)
        },
      },
      {
        Header: t('PA Index'),
        accessor: "pa_index",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        description: t('Press AI Keyword Index.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '100px' }}>{cell?.value !== null ? formatNumberWithCommas(cell?.value || 0) : '-'}</div>
          </>)
        },
      },
      {
        Header: t('Daily Search Volume'),
        accessor: "daily_search_volume",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 190 : 140,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('S.M Ranking'),
        accessor: "exposure_rank",
        filterable: true,
        sortable: true,
        thWidth: 160,
        thClass: 'align-middle text-end',
        description: t('The ranking of all Naver search-affiliated media in Naver News search results. (Based on today’s data.)'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '120px' }}>{(cell?.value === null) ? '-' : formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('Search Media'),
        accessor: "media_name",
        filterable: true,
        sortable: false,
        thClass: 'text-end align-middle',
        thWidth: i18n?.language === 'en' ? 150 : 130,
        description: t('All Naver search-affiliated media.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end hover-underline-primary pe-3" style={{ minWidth: i18n?.language === 'en' ? '110px' : '100px' }}>
              <Link
                className="nav-link"
                target="_blank"
                to={item?.news_link || ''} >
                {cell?.value || '-'}
              </Link>
            </div>
          </>)
        },
      },
      {
        Header: t('PA Media Ranking'),
        accessor: "affiliate_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of Press AI-affiliated media in Naver News search results. (Based on today’s data.)'),
        thWidth: i18n?.language === 'en' ? 180 : 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info">
            {cell?.value ?? '-'}
          </div>)
        },
      },
      {
        Header: t('PA Media'),
        accessor: "affiliate_media",
        filterable: true,
        sortable: false,
        thClass: 'align-middle text-end',
        thWidth: i18n?.language === 'en' ? 150 : 120,
        description: t("Press AI-affiliated media."),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-3">
            {cell?.value ?? '-'}
          </div>)
        },
      },
      {
        Header: t('Exposure Period'),
        accessor: "last_published_at",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 170 : 120,
        thClass: 'align-middle text-end',
        description: t('The last publication date among the four most recent articles in Naver News search (as of today).'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '140px' : '100px' }}>
              {item?.last_published_label ?? '-'}
            </div>
          )
        },
      },
      {
        Header: t('News Section'),
        accessor: "news_section_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of the news section in Naver search results (as of today).'),
        thWidth: i18n?.language === 'en' ? 150 : 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '120px' }} className="text-end pe-info">
            {item?.news_section_rank ?? '-'}
          </div>)
        },
      },

      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated At'),
        accessor: "updated_at",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            </div>
          )
        },
      },
      // {
      //   Header: t('Actions'),
      //   accessor: "__",
      //   thClass: 'align-middle text-center',
      //   thWidth: 120,
      //   sortable: false,
      //   Cell: (cell: any) => {
      //     const item: any = cell?.row?.original;
      //     return (
      //       <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '100px' }}>
      //         {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) &&
      //           <TooltipCustom
      //             title={t('Button View News')}
      //             id={`detail-cp-${item?.id}`}
      //           >
      //             <li className=" list-inline-item me-0" id={`detail-us-${item?.id}`}>
      //               <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
      //                 onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}
      //               >
      //                 {/* {t('Button View News')} */}
      //                 <i className="ri-eye-fill align-bottom"></i>
      //               </Link>
      //             </li>
      //           </TooltipCustom>
      //         }
      //         {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) && (
      //           <TooltipCustom
      //             title={t('Button Delete News')}
      //             id={`detail-cp-${item?.id}`}
      //           >
      //             <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
      //               <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
      //                 onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
      //               >
      //                 <i className="ri-delete-bin-3-fill align-bottom"></i>
      //               </Link>
      //             </li>
      //           </TooltipCustom>
      //         )}
      //       </ul>
      //     );
      //   },
      // },
    ],
    [i18n?.language, keywords?.list?.length, query, partners, userPermissions]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setListNews((prev: any) => ({
      list: [],
      total: 0,
    }));
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy, page: 1 });
    });
  }, []);

  const handleRefreshCategory = async () => {
    try {
      const res1: any = await getAllCategory();
      setListCategory((_prev) => res1?.data || []);
    } catch (error: any) {
      return error;
    }
  };

  const handleCallAllOption = async () => {
    try {
      const [res1, res2, res3, res4]: any = await Promise.all([getAllCategory(), getAllImageCategory({}), getAllPartners({}), allCategoryVote()]);
      const _listMediaPublished = filterMediaOptions(res3?.data || [])?.map((_p: any) => ({ label: _p?.name, value: `${_p?.id}` }));
      const _listReporter = filterMediaOptions(res3?.data || [])?.flatMap((_p: any) => (_p?.partner_reporters)?.map((_r: any) => ({
        partner_id: _r?.partner_id,
        label: `${_r?.reporter_id}  | ${_p?.name}`,
        value: `${_r?.reporter_id}`
      })));
      setListCategory((_prev) => res1?.data || []);
      setImageCategories((_prev: any) => res2?.data);
      setPartners((_prev: any) => res3?.data);
      setListMediaPublished((_prev: any) => _listMediaPublished || []);
      setListReporter((_prev: any) => _listReporter || []);
      setListCategoryVote((_prev: any) => res4?.data || []);

      if (query?.published_media_id) {
        const _media = _listMediaPublished?.find((_p: any) => String(_p?.value) === String(query?.published_media_id));
        setMediaPublishedSearch((_prev) => _media || null);
      }
      if (query?.reporter_id) {
        const _reporter = _listReporter?.find((_r: any) => String(_r?.value) === String(query?.reporter_id));
        setReporterIdSearch((_prev) => _reporter || null);
      }
    } catch (error: any) {
      return error;
    }
  };

  const listReporterFilter = useMemo(() => {
    return listReporter?.filter((_r: any) => (String(_r?.partner_id) === String(mediaPublishedSearch?.value) || !mediaPublishedSearch?.value));
  }, [listReporter, mediaPublishedSearch]);

  const handelChangeCategory = (category_id_search: string) => {
    const queryNew = {
      ...query,
      category_id: category_id_search,
      page: 1,
      time_request: + new Date()
    };
    // if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
    //   setListNews((prev: any) => ({
    //     list: [],
    //     total: 0,
    //   }));
    // }
    setQuery(queryNew);
  }


  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  }

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Boosting News')} | ${t('PRESS Ai')}`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);



  const refRight = useRef<any>(null);
  const refStart = useRef<any>(null);
  const [position, setPosition] = useState<any>({ left0: 0, top0: 20, left1: 20, left2: 30, top1: 20, top2: 20 });


  useEffect(() => {
    const getPosition = () => {
      if (refStart.current && modalBodyInnerRef.current && refRight.current) {
        const startRect = refStart.current.getBoundingClientRect();
        const leftRect = modalBodyInnerRef.current.getBoundingClientRect();
        const rightRect = refRight.current.getBoundingClientRect();

        setPosition((_prev: any) => ({ left0: startRect.left, left1: leftRect.left, left2: rightRect.left, top0: startRect.top, top1: leftRect.top, top2: rightRect.top }));
      }
    };

    // Timeout to ensure UI has rendered
    const timeoutId = setTimeout(() => {
      // Get position on mount
      getPosition();
    }, 0);

    // Optionally, track changes on window resize
    window.addEventListener("resize", getPosition);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", getPosition);
    };
  }, [JSON.stringify(newsDetail)]);


  const [status, setStatus] = useState<number>(0); // Tracks current status from API
  const [isRunning, setIsRunning] = useState<boolean>(false); // Tracks if the process is running
  const [buttonText, setButtonText] = useState<string>(''); // Button text to display

  const [idRunning, setIdRunning] = useState<number | string>('');
  const [isStopping, setIsStopping] = useState<boolean>(false);

  const [typeAction, setTypeAction] = useState<string>('');

  // Function to handle the POST request and start the process
  const startProcess = async () => {
    try {
      setIsRunning(true); // Set running state to true
      const response: any = await postGenerateBoostingNews({ type: "news:boosting:generate" });
      setIsRunning(false);
      if (response?.code === 200) {
        setStatus(0);
        setIdRunning((_prev) => response?.data?.id);
        setButtonText(`${String(response?.data?.created_at)?.split(' ')[1].slice(0, 5)}`); // Show `time` on the button
        setTypeAction((_prev) => '');
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Function to check the status (GET request)
  const checkStatus = async () => {
    try {
      const response: any = await getGenerateBoostingNews({ type: "news:boosting:generate" });
      if (response?.code === 200) {
        if (response?.data === null || response?.data?.status === 100) {
          setStatus(1); // Process is complete
          setIdRunning((_prev) => '');
          setButtonText(''); // Reset the button text
        } else {
          setStatus(0); // Process is still running
          setIdRunning((_prev) => response?.data?.id);
          setButtonText(`${String(response?.data?.created_at)?.split(' ')[1].slice(0, 5)}`);
        }
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Effect to poll the status every 5 seconds regardless of the state of `isRunning`

  // useEffect(() => {
  //   checkStatus();
  //   const timer = setInterval(() => {
  //     checkStatus(); // Check status every 5 seconds
  //   }, 10000);

  //   return () => clearInterval(timer); // Cleanup the timer on unmount
  // }, []);

  // Function to handle button click
  const handleButtonGenerateClick = async () => {
    if (isRunning) {
      return;
    }
    await startProcess(); // Start the process
  };

  const handleButtonStopClick = async () => {
    try {
      if (!idRunning) {
        return;
      }
      setIsStopping(true); // Set running state to true
      const response: any = await putGenerateBoostingNews(idRunning, { status: 99 });
      setIsStopping(false);
      if (response?.code === 200) {
        setTypeAction((_prev) => '');
        setStatus(1); // Process is complete
        setIdRunning((_prev) => '');
        setButtonText(''); // Reset the button text
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const handleAction = () => {
    if (typeAction === 'RUNNING') {
      handleButtonGenerateClick();
    }
    if (typeAction === 'STOPPING') {
      handleButtonStopClick();
    }
  };

  const handleOpenGenerateBoostingNewsV2 = () => {
    setIsOpenModalGenerateBoostingNewsV2((_prev) => true);
  };

  const handleCloseGenerateBoostingNewsV2 = () => {
    setIsOpenModalGenerateBoostingNewsV2((_prev) => false);
  };

  const handleCloseImportGenerateBoostingNews = () => {
    setIsOpenImportGenerateBoostingNews((_prev) => false);
  };


  const formatAddPreset = useCallback((_data: any | null = null) => {
    if (!_data) return null;
    return ({
      ..._data,
      preset: {
        media_id: _data?.preset?.media_id,
        media_code_id: _data?.preset?.media_code_id,
        media_reporter_id: _data?.preset?.media_reporter_id,
        reporter_byline: _data?.preset?.reporter_byline,
        tag: _data?.preset?.tag,
      }
    });
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Boosting News')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                  <div className="ribbon round-shape top-info-lg" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem', top: '11px' }}>{t('This data is analyzed every hour')}</div>
                  <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                    <Row className="g-4 align-items-center">
                      <div className="col-md-12 col-lg-5 mt-5 mt-sm-4">
                        <div>
                          <h5 className="card-title mb-0 d-flex flex-wrap gap-1 gap-xxl-2">
                            <span>
                              <span className="me-2">{t('Total')}:</span>
                              {(isKeywordLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywords?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                            <span className="text-muted">|</span>
                            <span className="d-flex">
                              <div className="me-2">{t('Unused Articles')}:</div>
                              {(isKeywordLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywords?.total?.article_unused_count || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                            <span className="text-muted">|</span>
                            <span className="d-flex">
                              <div className="me-2">{t('Used Articles')}:</div>
                              {(isKeywordLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywords?.total?.article_used_count || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-7 text-end mt-3 mt-lg-4">
                        <div className={`d-flex gap-3 flex-wrap justify-content-end padding-lg-right-info-${i18n?.language}`}>
                          {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={() => setIsOpenImportGenerateBoostingNews((_prev) => true)}
                          >
                            <i className="ri-upload-line align-bottom"></i>
                            <span className="ms-1">{t('Button Import Bulk Generate Boosting News')}</span>
                          </button>)}
                          {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={handleOpenGenerateBoostingNewsV2}
                          >
                            <i className="ri-add-line align-bottom"></i>
                            <span className="ms-1">{t('Button Generate Boosting News v2')}</span>
                          </button>)}
                        </div>
                      </div>
                      {/* <div className="col-12 col-md-12 col-xl-6 col-xxl-6  text-end mt-3 mt-md-4">
                        <div className={`d-flex gap-3 flex-wrap justify-content-end padding-lg-right-info-${i18n?.language}`}>
                          {isHavePermissionRole(ROLES_FOR_APP.BOOSTING_NEWS, userPermissions) && (<>
                            {!!buttonText && <button
                              type="button"
                              className="btn btn-danger add-btn rounded-pill"
                              id="create-btn"
                              onClick={() => setTypeAction((_prev: string) => 'STOPPING')}
                              disabled={isStopping}
                              style={{ width: '120px' }}
                            >
                              {t('Button Stop')}
                            </button>}
                            <button
                              type="button"
                              className="btn btn-success add-btn rounded-pill"
                              id="create-btn"
                              onClick={() => setTypeAction((_prev: string) => 'RUNNING')}
                              disabled={!status || isRunning}
                              style={{ width: '180px' }}
                            >
                              {!!buttonText ? <><span style={{ transform: 'translateY(-1px)' }} className="me-2"><Spinner size="sm" className="text-white align-middle"></Spinner></span>{t('Started at:')}</> : t('Button Generate')} {buttonText || ''}
                            </button>
                          </>)}
                        </div>
                      </div> */}
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-end mt-0">
                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Type')} isShow={true}>
                            <DropdownStatus
                              name="type"
                              dataList={KEYWORD_TYPE_OPTIONS_LANG || []}
                              placeholder={`${t("Type")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeSearch || null}
                              onChangeSelect={(e: any) => setTypeSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_KEYWORD_TYPE}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2' >
                          <LabelWrapper label={t('Content Type')} isShow={true}>
                            <DropdownOption
                              name="rank"
                              dataList={SECTION_TYPE_CONTENT_OPTIONS_LANG || []}
                              placeholder={`${t("Content Type")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeSectionContentSearch || null}
                              onChangeSelect={(e: any) => setTypeSectionContentSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            // colors={COLORS_SECTION_TYPE_CONTENT}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2' >
                          <LabelWrapper label={t('Status')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={STATUS_KEYWORD_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("Status")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={statusSearch || null}
                              onChangeSelect={(e: any) => setStatusSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={{
                                '0': 'success',
                                '1': 'danger',
                              } as any}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Article Status')} isShow={true}>
                            <DropdownStatus
                              name="status_article"
                              dataList={STATUS_ARTICLE_OPTIONS_LANG || []}
                              placeholder={`${t("Article Status")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={statusArticleSearch || null}
                              onChangeSelect={(e: any) => setStatusArticleSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={{
                                '1': 'success',
                                '0': 'danger',
                              } as any}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className=' mt-3 mt-xxl-2' >
                          <LabelWrapper label={t('S.M Ranking')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={RANK_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("S.M Ranking")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={rankSearch || null}
                              onChangeSelect={(e: any) => setRankSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_RANK_NEWS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className='mt-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startArticleCountSearch}
                            valueTo={endArticleCountSearch}
                            placeholderFrom={`${t('Article (Start)')}...`}
                            placeholderTo={`${t('Article (End)')}...`}
                            labelFrom={`${t('Article (Start)')}`}
                            labelTo={`${t('Article (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartArticleCountSearch(val)}
                            onChangeTo={(val) => setEndArticleCountSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className='mt-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startPAIndexSearch}
                            valueTo={endPAIndexSearch}
                            placeholderFrom={`${t('PA Index (Start)')}...`}
                            placeholderTo={`${t('PA Index (End)')}...`}
                            labelFrom={`${t('PA Index (Start)')}`}
                            labelTo={`${t('PA Index (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartPAIndexSearch(val)}
                            onChangeTo={(val) => setEndPAIndexSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className=' mt-3'  >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startDailyVolumeSearch}
                            valueTo={endDailyVolumeSearch}
                            placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                            placeholderTo={`${t('Daily Search Volume (End)')}...`}
                            labelFrom={`${t('Daily Search Volume (Start)')}`}
                            labelTo={`${t('Daily Search Volume (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartDailyVolumeSearch(val)}
                            onChangeTo={(val) => setEndDailyVolumeSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className='mt-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startAffiliateSearch}
                            valueTo={endAffiliateSearch}
                            placeholderFrom={`${t('PA Media Ranking (Start)')}...`}
                            placeholderTo={`${t('PA Media Ranking (End)')}...`}
                            labelFrom={`${t('PA Media Ranking (Start)')}`}
                            labelTo={`${t('PA Media Ranking (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartAffiliateSearch(val)}
                            onChangeTo={(val) => setEndAffiliateSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startLastPublishedSearch}
                            valueTo={endLastPublishedSearch}
                            placeholderFrom={`${t('Exposure Period (Start)')}...`}
                            placeholderTo={`${t('Exposure Period (End)')}...`}
                            labelFrom={`${t('Exposure Period (Start)')}`}
                            labelTo={`${t('Exposure Period (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartLastPublishedSearch(val)}
                            onChangeTo={(val) => setEndLastPublishedSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={12} lg={6} xl={6} xxl={4} className='mt-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startNewsSectionSearch}
                            valueTo={endNewsSectionSearch}
                            placeholderFrom={`${t('News Section (Start)')}...`}
                            placeholderTo={`${t('News Section (End)')}...`}
                            labelFrom={`${t('News Section (Start)')}`}
                            labelTo={`${t('News Section (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartNewsSectionSearch(val)}
                            onChangeTo={(val) => setEndNewsSectionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3' >
                          <LabelWrapper label={t('Task Keyword')} isShow={true}>
                            <DropdownOption
                              name="rank"
                              dataList={NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS_LANG || []}
                              placeholder={`${t("Task Keyword")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeTaskKeywordSearch || null}
                              onChangeSelect={(e: any) => setTypeTaskKeywordSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-0 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3' >
                          <LabelWrapper label={t('Media')} isShow={true}>
                            <DropdownOption
                              name="media"
                              dataList={listMediaPublished || []}
                              placeholder={`${t("Media")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={mediaPublishedSearch || null}
                              onChangeSelect={(e: any) => setMediaPublishedSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-0 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Search Media')} isShow={!!mediaSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Search Media')}...`}
                              value={mediaSearch}
                              onChange={(e) => setMediaSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-2 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Reporter ID')} isShow={true}>
                            <DropdownOption
                              name="reporter_id"
                              dataList={listReporterFilter || []}
                              placeholder={`${t("Reporter ID")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={reporterIdSearch || null}
                              onChangeSelect={(e: any) => setReporterIdSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            // colors={COLORS_SECTION_TYPE_CONTENT}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-2 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Search Reporter ID')} isShow={!!reporterNameSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Search Reporter ID')}...`}
                              value={reporterNameSearch}
                              onChange={(e) => setReporterNameSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={12} lg={12} xl={12} xxl={8} className='order-2 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Article Title')} isShow={!!titleSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Article Title')}...`}
                              value={titleSearch}
                              onChange={(e) => setTitleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={12} lg={12} xl={12} xxl={4} className="order-3 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-end justify-content-xl-end justify-content-xxl-end mt-3 mt-xxl-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 me-lg-2"
                              onClick={searchData}
                              disabled={isListNewsLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                  </div>
                  <div className="border border-dashed border-top-0 border-end-0 border-start-0">
                    <Col sm={12} md={12} xl={12} xxl={12} className="px-3 py-3">
                      <div>
                        <div className="d-flex gap-2 flex-wrap">
                          <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === '' ? 'bg-primary text-white' : 'border-gray text-secondary'}`}
                            onClick={(e) => { e.preventDefault(); handelChangeCategory('') }}
                          >
                            {t('All')}
                          </button>
                          {listCategory?.map((item) => (
                            <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === String(item?.id) ? `bg-primary text-white` : `border-gray text-secondary`}`} key={item?.id}
                              onClick={(e) => { e.preventDefault(); handelChangeCategory(`${item?.id}`) }}
                            >
                              {item?.name}
                            </button>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </div>
                  <div className="text-end my-2">
                    <Button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={() => setIsOpenLogGenerateBoostingNews(true)}
                    >
                      {t("Button Log Generate Boosting News")}
                    </Button>
                  </div>
                  <CardBody className="pt-0 px-0">
                    <div className="mx-3 my-4 mt-3">
                      <TableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card "
                        tableClass="align-middle sticky-table-boosting-news"
                        theadClass="table-light"
                        columns={columns}
                        data={keywords?.list?.length ? keywords?.list : []}
                        customPageSize={query.limit}
                        customPageIndex={query.page - 1}
                        totalRecords={keywords?.pagination?.total}
                        customPageCount={Math.ceil(Number(keywords?.pagination?.total) / Number(query?.limit || 300))}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isKeywordLoading}
                        isShowPagination={true}
                        isShowLoadingBottom={false}
                        isScrollToTop={true}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}</Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} className="toast---------text" pauseOnFocusLoss autoClose={2000} limit={2} />

        <Modal
          isOpen={!!isOpenModalNews}
          centered={true}
          size="xl"
          className={`border-header-footer modal-fullscreen`}
          scrollable={false}
          toggle={handleCloseModalNews}
          keyboard={true}
          innerRef={modalRef}
        >
          <ModalHeader toggle={handleCloseModalNews}>
            <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
              <div className="flex-grow-1">
                {t('Boosting News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span> {!!newsDetail?.keyword_sub && <> - <span style={{ backgroundColor: '#a8d2fb' }}>{newsDetail?.keyword_sub || ''}</span></>}
                <ButtonLanguage currentLang={currentLang} handleChangeLang={handleChangeLang} />
                {/* <span className={`mx-2 rounded-pill badge bg-${COLORS_STATUS_NEWS[`${newsDetail?.is_used || 0}`] || 'success'}`}>
                  {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(newsDetail?.is_used))?.label || ''}
                </span> */}
                <span key={newsDetail?.section} className={`rounded-pill me-2 badge bg-primary-subtle text-primary ms-2`}>
                  {newsDetail?.category?.name || ''}
                </span>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="position-relative">
            <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
              top: position?.top0,
              left: position?.left0 + 10,
              transform: `translateY(-${position?.top0 - 10}px)`,
              zIndex: 9,
              backgroundColor: 'var(--vz-secondary-bg)'
            }}>
              {t('List News')}
            </span>
            <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
              top: position?.top1,
              left: position?.left1 + 10,
              transform: `translateY(-${position?.top1 - 10}px)`,
              zIndex: 9,
              backgroundColor: 'var(--vz-secondary-bg)'
            }}>
              {t('Generated News')}
            </span>
            <span className="position-absolute text-primary fs-13 text-end px-2 d-none d-lg-block" style={{
              top: position?.top2,
              left: position?.left2 + 10,
              transform: `translateY(-${position?.top2 - 10}px)`,
              zIndex: 9,
              backgroundColor: 'var(--vz-secondary-bg)'
            }}>
              {typeShowInfoRight === 'SOURCE' ? t('Source') : t('Google Image')}
            </span>
            <div className="h-100-pc w-100 overflow-x-hidden">
              <Row className="w-100-pc px-0 h-100-pc">
                <Col lg={3} className="h-100-pc  mt-4 mt-md-0 mb-3 mb-lg-0" >
                  <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                    top: 0,
                    left: 5,
                    transform: `translateY(-${10}px)`,
                    zIndex: 9,
                    backgroundColor: 'var(--vz-secondary-bg)'
                  }}>
                    {t('News List')}
                  </span>
                  <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                    <div className={`box-source-image color-scrollbar-os overflow-x-hidden overflow-y-auto ms-0 ms-lg-3`} ref={refStart} style={{ border: '1.5px dashed var(--vz-success)', width: 'fit-content', minHeight: '80dvh' }}>
                      <div className="d-flex flex-column gap-3 mt-3 px-1 pb-5">
                        {(listNews?.list || [])?.map((_n, _idx) => (
                          <Card className={`position-relative border cursor-pointer  border-hover-success mb-0 ${String(_n?.id) === String(newsDetail?.id) ? 'border-success border-2' : ''}`} key={_n?.id} onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ..._n, index: _idx }) }}>
                            <CardBody style={{ position: 'relative' }}>
                              <div className="d-sm-flex" >
                                <div className="flex-grow-1">
                                  <div className="d-flex mb-3 justify-content-between align-items-center">
                                    <div>
                                      {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <></> : <><span className="text-muted fs-13">{t('Cluster Article Count')}:</span> {_n?.source_cluster_count ?? '-'}</>}
                                    </div>
                                    <div>
                                      <span className={`rounded-pill badge bg-${COLORS_STATUS_NEWS[`${_n?.is_used || 0}`] || 'success'}`}>
                                        {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(_n?.is_used))?.label || ''}
                                      </span>
                                    </div>
                                  </div>
                                  <h5 className="">
                                    <span className="align-text-top  me-1">{!!_n?.is_completed ? <i className='ri-checkbox-line text-success fs-20' /> : <i className='ri-checkbox-indeterminate-line text-danger fs-20' />}</span>
                                    <HighlightText text={_n?.title || ''} keyword={_n?.keyword || ''} opacity_bg={0.7} />
                                  </h5>
                                  <ul className="list-inline mb-0 d-flex justify-content-between">
                                    <li className="list-inline-item">
                                    </li>
                                    <li className="list-inline-item">
                                      {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <><span className="text-muted fs-13">{t('Created at2')}:</span> {_n?.created_at || ''}</> : <><span className="text-muted fs-13">{t('Source Publish Date')}:</span> {_n?.source_publish_time || ''}</>}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </CardBody>
                            <span className={`position-absolute text-${String(_n?.id) === String(newsDetail?.id) ? 'success' : 'muted'} fs-13 text-end px-2`} style={{
                              top: '-10px',
                              left: 5,
                              zIndex: 0,
                              backgroundColor: 'var(--vz-secondary-bg)'
                            }}>
                              #{_n?.id}
                            </span>
                          </Card>
                        ))}
                      </div>
                      <div className="text-center my-2 position-absolute" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        {!!isListNewsLoading && <Spinner size="sm" className="text-success fs-20 align-middle" style={{ width: '30px', height: '30px' }}></Spinner>}
                      </div>
                    </div>
                    {/* isShowVote={TEXT_NAME_CATEGORY_IS_STAR_TREND_KEYWORD?.includes(newsDetail?.category?.name || '')} */}
                    <BoxVoteKeyword isShowVote={TEXT_NAME_CATEGORY_IS_STAR_TREND_KEYWORD?.includes(newsDetail?.category?.name || '')} ref={modalBodyInnerRef} categories={listCategoryVote} keyword={newsDetail?.keyword} created_date={newsDetail?.date} onSetVoteKeywordInsert={onSetVoteKeywordInsert} />
                  </Row>
                </Col>
                <Col lg={6} className="h-100-pc mt-2 mt-md-0">
                  <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                    top: 0,
                    left: 5,
                    transform: `translateY(-${10}px)`,
                    zIndex: 9,
                    backgroundColor: 'var(--vz-secondary-bg)'
                  }}>
                    {t('Generated News')}
                  </span>
                  <div ref={modalBodyInnerRef} className="inner-modal-body color-scrollbar-os position-relative p-0 editor-border-radius-0" style={{ border: '1.5px dashed var(--vz-success)' }}>
                    <BoxGeneratedNews ref={refContentNews} newsDetail={newsDetail} imageInsert={imageInsert} voteInsert={voteInsert} isSubKeywordFrequency={false} isShowStatusAndMedia={true} isEdit={true} isHighlightDate={true} handleCopied={handleCopied} />
                  </div>
                </Col>
                <Col lg={3} className="h-100-pc ms-0 ms-lg-0 pe-3 me-lg-0 mt-4  mt-md-0" >
                  <span className="position-absolute text-primary fs-13 text-end px-2 d-block d-lg-none" style={{
                    top: 0,
                    left: 5,
                    transform: `translateY(-${10}px)`,
                    zIndex: 9,
                    backgroundColor: 'var(--vz-secondary-bg)'
                  }}>
                    {typeShowInfoRight === 'SOURCE' ? t('Source') : t('Google Image')}
                  </span>
                  {typeShowInfoRight === 'IMAGE' ? <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                    <div className={`box-source-image overflow-y-hidden overflow-x-hidden px-0 `}>
                      <BoxImageSearch keyword={newsDetail?.keyword || ''} ref={modalBodyInnerRef} news_id={newsDetail?.id} categories={imageCategories} onSetImageInsert={onSetImageInsert} resetCursorToStart={resetCursorToStart} />
                    </div>
                  </Row> :
                    <div className={`row h-100-pc overflow-y-auto color-scrollbar-os align-content-${formatGetSource(newsDetail)?.length === 2 ? 'start' : 'between'} gap-3 gap-lg-${formatGetSource(newsDetail)?.length > 2 ? 2 : 0}`} ref={refRight}>
                      {formatGetSource(newsDetail)?.length ? formatGetSource(newsDetail)?.map((item: any, index: number) => {
                        if (!modalSourceInnerRefs.current[index]) {
                          modalSourceInnerRefs.current[index] = React.createRef<HTMLDivElement>().current;
                        }
                        return (
                          <div ref={(el) => (modalSourceInnerRefs.current[index] = el)} key={index} className={`color-scrollbar-os position-relative box-source-news chill-${formatGetSource(newsDetail)?.length} ${formatGetSource(newsDetail)?.length === 1 ? 'h-100' : ''}`}>
                            <BoxSourceNews item={item} index={index} keyword={newsDetail?.keyword} keyword_sub={newsDetail?.keyword_sub} session={newsDetail?.section} isSubKeywordFrequency={false} />
                          </div>
                        )
                      }) : <div ref={(el) => (modalSourceInnerRefs.current[0] = el)} style={{ height: '100%' }} className={`color-scrollbar-os position-relative box-source-news chill-1`}>
                      </div>}
                    </div>
                  }
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter className="position-relative footer-button-new" lang={i18n?.language || 'en'}>
            <BoxFooterNews
              // newsDetail={newsDetail}
              newsDetail={formatAddPreset(newsDetail)}
              isListNewsLoading={isListNewsLoading}
              type_page_no_param={query?.type_page_no_param}
              currentLang={currentLang}
              isSaving={isSaving}
              isShowButtonGenerateNews={String(newsDetail?.news_type) !== String(KEYWORD_TYPE.CONTENT)}
              isShowSave={true}
              isShowCategoryOnPublish={true}
              publishNewsType={PUBLISH_NEWS_TYPE.BOOSTING_NEWS}
              handlePreviousNews={handlePreviousNews}
              handleNextNews={handleNextNews}
              handleDownloaded={handleDownloaded}
              handlePublished={handlePublished}
              handleUnPublished={handleUnPublished}
              handleGenerateNews={handleGenerateNews}
              onCloseClick={onCloseClick}
              onSaveClick={onSaveClick}
              onShowInfoRightClick={onShowInfoRightClick}
              typeShowInfoRight={typeShowInfoRight}
              partners={partners}
              categories={listCategory}
            />
          </ModalFooter>
        </Modal>

        <ModalGenerateBoostingNewsV2
          isOpen={isOpenModalGenerateBoostingNewsV2}
          onRefresh={triggerRefresh}
          onClose={handleCloseGenerateBoostingNewsV2}
        />

        <ModalImportGenerateBoostingNews
          isOpen={isOpenImportGenerateBoostingNews}
          onRefresh={triggerRefresh}
          onClose={handleCloseImportGenerateBoostingNews}
        />

        <ModalLogGenerateBoostingNews
          isOpen={isOpenLogGenerateBoostingNews}
          onClose={() => setIsOpenLogGenerateBoostingNews(false)}
        />

        <ModalConfirm
          header={t('Button Delete News')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />

        <ModalConfirm
          header={t('Button Generate')}
          textButtonConfirm={t('Button Generate')}
          classButtonConfirm={'btn-success'}
          title={t("Do you want to proceed?")}
          content={t("All articles for the keywords will be generated.")}
          isOpen={typeAction === 'RUNNING'}
          isLoading={isRunning}
          classIconButtonConfirm=''
          isShowIcon={false}
          onClose={() => setTypeAction((_prev: string) => '')}
          onConfirm={handleAction}
        />

        <ModalConfirm
          header={t('Button Stop')}
          textButtonConfirm={t('Button Stop')}
          classButtonConfirm={typeAction === 'RUNNING' ? 'btn-success' : 'btn-danger'}
          title={t("Do you want to proceed?")}
          content={t("All articles for the keywords will be stopped.")}
          isOpen={typeAction === 'STOPPING'}
          isLoading={isStopping}
          classIconButtonConfirm=''
          isShowIcon={false}
          onClose={() => setTypeAction((_prev: string) => '')}
          onConfirm={handleAction}
        />
      </div >
    </React.Fragment >
  );
};

export default BoostingNewsList;